/* eslint-disable */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Breadcrumb from "components/layout/breadcrumb/Breadcrumb";
import Transition from "components/layout/transition/Transition";
import FilterContainer from "components/containers/FilterContainer";
import HeaderContainer from "components/containers/HeaderContainer";
import ContentContainer from "components/containers/ContentContainer";
import InputFilter from "components/inputs/InputFilter";
import InputFilterDate from "components/inputs/InputFilterDate";
import Button from "@material-ui/core/Button";
import CollaboratorsJustificationsTable from "./CollaboratorsJustificationsTable";
import ClockRecordContext from "context/hrModule/clockRecord/clockRecordContext";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import GetApp from "@material-ui/icons/GetApp";
import Dissatisfied from "@material-ui/icons/SentimentVeryDissatisfied";
import Footer from "components/layout/Footer";
import { useStyles } from "components/layout/CommonStyles";
import { GetGeneralPermissionForAction } from "utils/permissions/GetGeneralPermissionForAction";
import { isSameDate } from "utils/dates/IsSameDate";
import {
  JustificationsStatusArray,
  GetJustificationStatus,
  JustificationsTypeArray,
  GetJustificationType,
} from "./ScreenUtils";
import { Screen, Allow } from "global/constants";
import { FormatDateToFront } from "utils/dates/FormatDateToFront";
import { dateToBR } from "utils/dates/DateToBRr";

import { screenStyles } from "./Styles";
import { nameSearchFilter } from "utils/filter/filterFields";

const CollaboratorsJustifications = () => {
  const classes = useStyles();
  const styles = screenStyles();
  const [t] = useTranslation();
  const [loading, setLoading] = useState(true);

  const clockRecordContext = useContext(ClockRecordContext);

  const [findText, setFindText] = useState("");
  const [filterJustificationDate, setFilterJustificationDate] = useState(null);
  const [filterRequester, setFilterRequester] = useState("");
  const [filterJustificationType, setFilterJustificationType] = useState("ALL");
  const [filterJustifiedDate, setFilterJustifiedDate] = useState(null);
  const [filterStatus, setFilterStatus] = useState("ALL");
  const [dataFilter, setDataFilter] = useState([]);

  const [canClick, setCanClick] = useState(false);

  const { collaboratorsJustifications, getCollaboratorsJustifications } =
    clockRecordContext;

  if (localStorage.getItem("auth-token") !== null) {
    var auth = JSON.parse(localStorage.getItem("auth-token"));
  }

  const hasItens =
    collaboratorsJustifications && collaboratorsJustifications.length > 0;
  const [hasNoResult, setHasNoResult] = useState(
    hasItens && dataFilter && dataFilter.length === 0
  );

  const fetchData = () => {
    getCollaboratorsJustifications(auth.id, setLoading);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (collaboratorsJustifications) {
      setDataFilter(collaboratorsJustifications);
      setHasNoResult(false);
      setLoading(false);
    }
  }, [collaboratorsJustifications]);

  useEffect(() => {
    if (collaboratorsJustifications && collaboratorsJustifications.length > 0) {
      const { newDataFilter, textNoFound } = applyFilter(
        collaboratorsJustifications
      );

      if (newDataFilter.length === 0) {
        setDataFilter([]);
        setHasNoResult(true);
        setFindText(textNoFound);
      } else {
        setDataFilter(newDataFilter);
        setHasNoResult(false);
        setFindText("");
      }

      setDataFilter(newDataFilter);
    }
  }, [
    filterJustificationDate,
    filterRequester,
    filterJustificationType,
    filterStatus,
    filterJustifiedDate,
  ]);

  const applyFilter = data => {
    let newDataFilter = [];
    let textNoFound = "";

    newDataFilter = data;

    if (filterStatus && filterStatus !== "ALL") {
      newDataFilter = newDataFilter.filter(
        item => item.status && item.status === filterStatus
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = GetJustificationStatus(filterStatus);
    }

    if (filterRequester) {
      newDataFilter = newDataFilter.filter(
        item =>
          item.requester.name &&
          nameSearchFilter(item.requester.name, filterRequester)
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = filterRequester;
    }

    if (filterJustificationDate && !isNaN(filterJustificationDate)) {
      newDataFilter = newDataFilter.filter(
        item =>
          item.dateCreated &&
          isSameDate(
            FormatDateToFront(item.dateCreated),
            filterJustificationDate
          )
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = dateToBR(filterJustificationDate);
    }

    if (filterJustifiedDate && !isNaN(filterJustifiedDate)) {
      newDataFilter = newDataFilter.filter(
        item =>
          (item.requestedDate &&
            isSameDate(
              FormatDateToFront(item.requestedDate),
              filterJustifiedDate
            )) ||
          (item.endDate &&
            FormatDateToFront(item.requestedDate).getTime() <=
              filterJustifiedDate.getTime() &&
            FormatDateToFront(item.endDate).getTime() >=
              filterJustifiedDate.getTime())
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = dateToBR(filterJustifiedDate);
    }

    if (filterJustificationType && filterJustificationType !== "ALL") {
      newDataFilter = newDataFilter.filter(
        item => item.class && item.class === filterJustificationType
      );

      if (!textNoFound && newDataFilter.length === 0)
        textNoFound = GetJustificationType(filterJustificationType);
    }

    return { newDataFilter, textNoFound };
  };

  useEffect(() => {
    if (
      filterJustificationDate ||
      filterRequester ||
      filterJustificationType ||
      filterStatus ||
      filterJustifiedDate
    ) {
      setCanClick(true);
    } else {
      setCanClick(false);
    }
  }, [
    filterJustificationDate,
    filterRequester,
    filterJustificationType,
    filterStatus,
    filterJustifiedDate,
  ]);

  return (
    <React.Fragment>
      <Transition loading={loading} newDesign={true}>
        <HeaderContainer>
          <Breadcrumb
            newDesign={true}
            routes={[
              {
                label: t("HR.humanResource"),
                to: "/HumanResources",
              },
              { label: t("HR.clock") },
              { label: t("HR.collaboratorsJustifications") },
            ]}
          />
          <div className="container-headerNewDesign">
            <h1 className={classes.titleNewDesign}>
              {t("HR.collaboratorsJustifications")}
            </h1>
          </div>
        </HeaderContainer>
        <ContentContainer>
          <Paper>
            <div className="cabecalho">
              {t("HR.manageJustifications").toUpperCase()}
            </div>
            <FilterContainer>
              <InputFilterDate
                filterValue={filterJustificationDate}
                setFilter={setFilterJustificationDate}
                label={"GENERAL.solicitationDate"}
              />
              <InputFilter
                filterValue={filterRequester}
                setFilter={setFilterRequester}
                label={"GENERAL.requester"}
              />
              <InputFilter
                filterValue={filterJustificationType}
                setFilter={setFilterJustificationType}
                label={"HR.justificationType"}
                isSelect
                arraySelected={JustificationsTypeArray}
              />
              <InputFilterDate
                filterValue={filterJustifiedDate}
                setFilter={setFilterJustifiedDate}
                label={"HR.justifiedDate"}
              />
              <InputFilter
                filterValue={filterStatus}
                setFilter={setFilterStatus}
                label={"GENERAL.status"}
                isSelect
                arraySelected={JustificationsStatusArray}
              />
            </FilterContainer>
            <React.Fragment>
              <CollaboratorsJustificationsTable
                rows={dataFilter}
                toFirstPage={canClick}
                headers={[
                  "id",
                  "dateCreated",
                  "requester",
                  "class",
                  "requestedDate",
                  "status",
                  "endDate",
                ]}
                visibleHeaders={[
                  "Data da Solicitação",
                  "Solicitante",
                  "Tipo de Justificativa",
                  "Data Justificada",
                  "Status",
                  "",
                  "",
                ]}
                sortedFields={[
                  "dateCreated",
                  "requester",
                  "class",
                  "requestedDate",
                  "status",
                ]}
                mainField="dateCreated"
              />

              {!hasItens && (
                <div className={styles.noJustificationsWrapper}>
                  <h2>{t("HR.noCollaboratorsJustificationsMessage")}</h2>
                  <h4>{t("HR.noCollaboratorsJustificationsSubMessage")}</h4>
                </div>
              )}
              {dataFilter.length === 0 && findText && (
                <div className={classes.noParticipantsMessage}>
                  <div>
                    <Dissatisfied className={classes.notFoundIconStyle} />
                  </div>
                  <h2>{t("GENERAL.noResultsFound")}</h2>
                  <h5>{`Sua busca por "${findText}" não retornou resultados.`}</h5>
                </div>
              )}
            </React.Fragment>
          </Paper>
        </ContentContainer>
        <Footer />
      </Transition>
    </React.Fragment>
  );
};

export default CollaboratorsJustifications;
